import React from 'react';
import './Facilities.css';
import { FaProcedures, FaSyringe, FaPills, FaFlask, FaAmbulance, FaUserMd, FaXRay, FaWheelchair, FaNotesMedical, FaHeartbeat, FaBrain, FaStar, FaMicroscope, FaBed } from 'react-icons/fa';

const Facilities = () => {
    const facilitiesList = [
        {
            icon: <FaAmbulance />,
            title: "24x7 Emergency",
            description: "Round-the-clock emergency care with rapid response teams and advanced life support systems."
        },
        {
            icon: <FaBed />,
            title: "10 Bedded Casualties",
            description: "Dedicated casualty area with 10 beds for immediate triage and stabilization of patients."
        },
        {
            icon: <FaProcedures />,
            title: "Transplant Suite Rooms",
            description: "Sterile non-infectious transplant suites designed for post-operative recovery and isolation."
        },
        {
            icon: <FaMicroscope />,
            title: "Endoscopy & Bronchoscopy Suites",
            description: "Advanced suites for diagnostic and therapeutic endoscopic and lumbar procedures."
        },
        {
            icon: <FaNotesMedical />,
            title: "24x7 Diagnosis Services",
            description: "Comprehensive diagnostic services available anytime for accurate and timely results."
        },
        {
            icon: <FaHeartbeat />,
            title: "Trauma Care",
            description: "Specialized trauma center equipped to handle critical injuries and complex emergencies."
        },
        {
            icon: <FaBed />,
            title: "Bedded Day Care MICU",
            description: "Specialized Medical Intensive Care Unit for day care procedures and monitoring."
        },
        {
            icon: <FaFlask />,
            title: "Advanced Laboratory Services",
            description: "State-of-the-art fully automated pathology lab for precise clinical testing."
        },
        {
            icon: <FaBrain />,
            title: "Neuro ICU",
            description: "Dedicated Intensive Care Unit for neurological patients requiring specialized monitoring."
        },
        {
            icon: <FaStar />,
            title: "World-Class Amenities",
            description: "Premium patient rooms and waiting areas designed for comfort and healing."
        },
        {
            icon: <FaProcedures />,
            title: "2 SICU with 10 beds each",
            description: "Two Surgical Intensive Care Units with 10 beds each for post-surgical recovery."
        },
        {
            icon: <FaSyringe />,
            title: "Advanced 24x7 Dialysis",
            description: "Modern dialysis center providing round-the-clock renal replacement therapy."
        },
        {
            icon: <FaPills />,
            title: "Pharmacy 24 x 7",
            description: "Well-stocked in-house pharmacy ensuring availability of critical medicines at all times."
        },
        {
            icon: <FaWheelchair />,
            title: "Comprehensive Neuro & Physiotherapy Unit",
            description: "Integrated rehabilitation unit for neurological and physical therapy support."
        }
    ];

    return (
        <div className="facilities-page">
            <div className="facilities-hero">
                <div className="container">
                    <h1>World-Class Facilities</h1>
                    <p>Combining advanced technology with compassionate care to ensure the best outcomes for our patients.</p>
                </div>
            </div>

            <section className="facilities-grid-section">
                <div className="container">
                    <div className="facilities-grid">
                        {facilitiesList.map((item, index) => (
                            <div key={index} className="facility-card">
                                <div className="facility-icon">
                                    {item.icon}
                                </div>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Facilities;
